module.exports = __webpack_public_path__ + "static/img/yshh1-3.8f4fe36.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/yshh1-3.png
// module id = 777
// module chunks = 0